import { Box, Typography } from '@mui/material';
import React from 'react'
import { Motion } from './Motion';
import { fontLink, fullCenter } from '../base';

export default function BaseButton({ text = '', handleSubmit = () => { }, sx = {}, sxText = {}, sxButton = {}, disabled = false, sxProps = {} }) {
    return (
        <Box sx={{ mt: '32px', ...sx }}>
            <Motion scale={1.02}>
                <Box
                    sx={{
                        minWidth: '142px',
                        height: '55px',
                        borderRadius: "999px",
                        textTransform: "none",
                        ...fontLink,
                        fontWeight: 600,
                        backgroundColor: "#0165F4",
                        ":hover": { backgroundColor: "#0165F4" },
                        ...fullCenter,
                        cursor: 'pointer',
                        ...sxButton
                    }}
                    onClick={() => {
                        if (disabled) {
                            return;
                        }
                        handleSubmit();
                    }}
                    {...sxProps}
                >
                    <Typography sx={{ whiteSpace: 'nowrap', color: 'white', fontWeight: 'bold', px: '24px', ...sxText }}>
                        {text}
                    </Typography>
                </Box>
            </Motion>
        </Box>
    )
}
